// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M8 4H16V1H18V4H22V9H2V4H6V1H8V4Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M22 11.0037V22H2V11.0037H22ZM11.2572 19.9068L16.9141 14.2499L15.4999 12.8357L11.2572 17.0783L9.13589 14.957L7.72168 16.3712L11.2572 19.9068Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-calendar-2-filled')
export default class Calendar2FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'calendar-2-filled',
    }
  }
}
